/**
 * Reading Session Log API Service
 * שליחת נתוני session לשרת
 */

import axiosInstance from './axios-instance';
import { ReadingSessionLogData } from '../analytics/reading-session-logger.service';

export interface ReadingSessionLogRequest {
  session_start: string; // ISO string
  session_end?: string; // ISO string
  duration_ms?: number;
  total_words: number;
  correct_words: number;
  error_words: number;
  accuracy_percentage: number;
  browser_name: string;
  browser_version: string;
  os_name: string;
  os_version: string;
  device_type: string;
  user_agent: string;
  status: string;
  completion_reason: string;
  book_id?: number;
  text_entity_id?: number;
}

/**
 * Save reading session log to server
 */
export async function saveReadingSessionLog(
  data: ReadingSessionLogData
): Promise<void> {
  const requestData: ReadingSessionLogRequest = {
    session_start: data.sessionStart.toISOString(),
    session_end: data.sessionEnd?.toISOString(),
    duration_ms: data.durationMs,
    total_words: data.totalWords,
    correct_words: data.correctWords,
    error_words: data.errorWords,
    accuracy_percentage: data.accuracyPercentage,
    browser_name: data.deviceInfo.browserName,
    browser_version: data.deviceInfo.browserVersion,
    os_name: data.deviceInfo.osName,
    os_version: data.deviceInfo.osVersion,
    device_type: data.deviceInfo.deviceType,
    user_agent: data.deviceInfo.userAgent,
    status: data.status,
    completion_reason: data.completionReason,
    book_id: data.bookId,
    text_entity_id: data.textEntityId,
  };

  await axiosInstance.post('/reading-session-log', requestData);
}

